import React from 'react'

const ArtistForm = ({
  artist,
  index,
  onArtistChange,
  onRemove
}) => (
  <div className="bg-white/5 border border-white/20 rounded-xl p-4">
    <div className="space-y-3">
      <div className="flex gap-3">
        <input
          type="text"
          value={artist.name || ''}
          onChange={(e) => onArtistChange(index, 'name', e.target.value)}
          placeholder="Enter artist name..."
          className="flex-1 px-4 py-3 bg-white/5 border border-white/20 rounded-xl text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300 hover:bg-white/10"
          autoFocus
        />
        <button
          type="button"
          onClick={() => onArtistChange(index, 'confirmed', true)}
          disabled={!artist.name?.trim()}
          className="bg-green-600 hover:bg-green-700 disabled:bg-gray-600 disabled:opacity-50 text-white font-medium py-3 px-3 rounded-xl transition-all duration-300"
        >
          ✓
        </button>
        <button
          type="button"
          onClick={() => onRemove(index)}
          className="bg-red-600 hover:bg-red-700 text-white font-medium py-3 px-3 rounded-xl transition-all duration-300"
        >
          ✕
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div>
          <label className="block text-xs font-medium text-gray-300 mb-1">
            Performance Date
          </label>
          <input
            type="date"
            value={artist.performanceDate || ''}
            onChange={(e) => onArtistChange(index, 'performanceDate', e.target.value)}
            className="w-full px-3 py-2 bg-white/5 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300 hover:bg-white/10 text-sm"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-300 mb-1">
            Set Time (optional)
          </label>
          <input
            type="text"
            value={artist.setTime || ''}
            onChange={(e) => onArtistChange(index, 'setTime', e.target.value)}
            placeholder="e.g., 9:30 PM, 21:30..."
            className="w-full px-3 py-2 bg-white/5 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300 hover:bg-white/10 text-sm"
          />
        </div>
      </div>

      <div>
        <label className="block text-xs font-medium text-gray-300 mb-1">
          Performance Details
        </label>
        <input
          type="text"
          value={artist.performance || ''}
          onChange={(e) => onArtistChange(index, 'performance', e.target.value)}
          placeholder="e.g., Main Stage, Day 2, Special Set..."
          className="w-full px-3 py-2 bg-white/5 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300 hover:bg-white/10 text-sm"
        />
      </div>
    </div>
  </div>
)

export default ArtistForm